import GameConfig from "../core/data/GameConfig";
import LoadBatch from "../core/LoadBatch";
import F84Game from "../Game";
import { CharacterUnlockData } from "../game/MissionsState";
import PlayerData from "../PlayerData";

export default class LoadBatches {

    static get Global(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("global");
        if (batch.assets.size == 0) {
            
            //batch.addAtlas("global", "./assets/batches/", "global-batch", "global-batch");

            batch.addImages("./assets/images/missions/", {
                missionsBG: "lmu-ui-missions-bg",
                starBurstImg: "lmu-ui-missions-starburst",
            });

            batch.addImages("./assets/images/confirm-quit/", {
                cqTextBacker: "lmu-ui-quit-text-backer",
                cqHeader: "lmu-ui-quit-header",
                cqCheckBtn: "lmu-ui-quit-btn-check",
                exitBtn: "lmu-ui-quit-btn-x",
            });

            batch.addImages("./assets/images/how-to-play/lmu-ui-", {
                helpBG: "help-container",
                helpImgWeb1Web: "help-img-1-desktop",
                helpImgWeb1Mobile: "help-img-1-mobile",
                helpImgWeb2Web: "help-img-2-desktop",
                helpImgWeb2Mobile: "help-img-2-mobile",
                helpImgWeb3: "help-img-3",
                helpImgWeb4: "help-img-4",
                okButton: "btn-ok",
                headerYellow: "header-yellow"
            });

            batch.addImages("./assets/images/pause-screen/", {
                homeBtn: "lmu-ui-pause-btn-home",
                pauseBacker: "lmu-ui-pause-quit-backer",
            });

            batch.addImages("./assets/images/shop/lmu-ui-store-", {
                shopBGGlow: "bg-glow",
            });

            batch.addImages("./assets/images/shop/", {
                soundButtonOff: "lmu-ui-store-btn-sound-off",
                soundButtonOn: "lmu-ui-store-btn-sound",
            });

            batch.addImages("./assets/images/recap/", {
                shopButton: "lmu-splash-shop-btn",
            });

            batch.addImages("./assets/images/pause-screen/lmu-ui-pause-", {
                pausePlayBtn: "btn-play",
            });

            batch.addImages("./assets/images/shop/lmu-ui-", {
                shopBaseBG: "base-bg",
            });

            batch.addImages("./assets/images/ui/lmu-ui-", {
                tutHand: "ftue-hand",
                tutDots: "ftue-dottedline",
                tutHandLift: "ftue-hand-fingerlift",
                tutSlamBacker: "ftue-slam-backer",
                tutSlamTriangle: "ftue-slam-speechtriangle",
            });

            batch.addImages("./assets/images/shop/lmu-ui-store-", {
                shopBuyBtn: "btn-item-buy-green",
                shopBuyBtnLocked: "btn-item-buy",
            });

            batch.addSpine("explosion-generic", "./assets/animations/explosion-generic/", "wb-explosion-generic", true);

            batch.addSounds("./assets/audio/", {
                click: "ui-button-press",
                music: "looney-music-loop",
                coinCollect: "coin-collect",
            }, ".mp3");
        }
        return batch;
    }

    static get Transition(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("screen-transition");
        if (batch.assets.size == 0) {

        }
        return batch;
    }

    static get Menu(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("menu");
        if (batch.assets.size == 0) {      
            //batch.addAtlas("menu", "./assets/batches/", "menu-batch", "menu-batch");

            batch.addImages("./assets/images/splash/lmu-splash-", {
                resetButton: "reset-btn",
            });

            batch.addImages("./assets/images/ui/lmu-ui-", {
                pauseButtonBacker: "pause-button-backer",
            });

            batch.addAtlas("storyAtlas1", "./assets/images/story-screen/", "storyAtlas1", "storyAtlas1", false);
            batch.addAtlas("storyAtlas2", "./assets/images/story-screen/", "storyAtlas2", "storyAtlas2", false);
            batch.addAtlas("storyAtlas3", "./assets/images/story-screen/", "storyAtlas3", "storyAtlas3", false);
            batch.addAtlas("film-strips", "./assets/images/story-screen/", "film-strips", "film-strips", false);

            batch.addImages("./assets/images/story-screen/",{
                skipBtn: "lmu-ui-btn-skip",
                storyTextBG: "lmu-ui-strory-text-bg",
            });

            batch.addSounds("./assets/audio/", {
                filmReelSFX: "film-reel-story-sfx",
            });
        }
        return batch;
    }

    static get Gameplay(): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("gameplay");
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/gameplay/characters/batman-slam/", {
                batmanRope: "wb-mash-batman-rope",
                batmanHook: "wb-mash-batman-hook",
            });

            batch.addImages("./assets/images/missions/", {
                missionsBacker: "lmu-ui-missions-clapboard",
                coinPriceBacker: "lmu-ui-missions-coinprice-backer",
                missionCoin: "lmu-ui-coin",
                meterEmpty: "lmu-ui-missions-meter-empty",
                meterGreenFill: "lmu-ui-missions-meter-green-slice",
                meterRedFill: "lmu-ui-missions-meter-red-slice",
                nextCharImg: "lmu-ui-missions-nextchar",
                nextCharBacker: "lmu-ui-missions-nextchar-backer",
                missionCheck: "lmu-ui-missions-coinprice-check",
            });

            batch.addImages("./assets/images/shop/lmu-ui-store-", {
                missionsNextBtn: "btn-play",
                missionsBackBtn: "btn-back",
            });

            batch.addImages("./assets/images/recap/", {
                shopBadge: "lmu-ui-recap-alert",
                recapBacker: "lmu-ui-recap-backer",
                recapHome: "lmu-ui-recap-btn-home",
                recapReplay: "lmu-ui-recap-btn-replay",
                recapDistBacker: "lmu-ui-recap-coinsdistance-backer",
                recapHeader: "lmu-ui-recap-header",
                recapDistIcon: "lmu-ui-hud-icon-distance",
                recapBedrock: "lmu-ui-recap-gppic-bedrock",
                recapGotham: "lmu-ui-recap-gppic-gotham",
                recapHaunted: "lmu-ui-recap-gppic-haunted",
                recapMetropolis: "lmu-ui-recap-gppic-metropolis",
            });

            batch.addImages("./assets/images/pause-screen/lmu-ui-pause-", {
                pauseHelpBtn: "btn-help",
                pauseHomeBtn: "btn-home",
                pauseSoundBtn: "btn-sound",
                pauseSoundBtnOff: "btn-sound-off",
                pauseBtnBacker: "button-backer",
                pauseHeader: "header",
            });

            batch.addImages("./assets/images/powerups/", {
                bugsBatRollerSkates: "wb-mash-bugs-batman-rollerskates",
            });

            batch.addImages("./assets/images/character-unlock/", {
                recapCharHeader: "lmu-ui-recap-char-header",
                recapFilmImg: "lmu-ui-recap-char-film",

                // bugsFredFlinstoneLockedRecap: "lmu-ui-recap-bugs-flint-locked",
                // bugsFredFlinstoneRecap: "lmu-ui-recap-bugs-flint",
                // bugsFredScoobyLockedRecap: "lmu-ui-recap-bugs-scooby-locked",
                // bugsFredScoobyRecap: "lmu-ui-recap-bugs-scooby",

                // daffySupermanLockedRecap: "lmu-ui-recap-daffy-sup-locked",
                // daffySupermanRecap: "lmu-ui-recap-daffy-sup",
                // daffyBatmanRecap: "lmu-ui-recap-daffy-bat",
                // daffyBatmanLockedRecap: "lmu-ui-recap-daffy-bat-locked",

                // lolaFlintstonesRecap: "lmu-ui-recap-lola-flint",
                // lolaFlintstonesLockedRecap: "lmu-ui-recap-lola-flint-locked",
                // lolaDaphneRecap: "lmu-ui-recap-lola-scooby",
                // lolaDaphneLockedRecap: "lmu-ui-recap-lola-scooby-locked",
                // lolaWonderwomanRecap: "lmu-ui-recap-lola-wonder",
                // lolaWonderwomanLockedRecap: "lmu-ui-recap-lola-wonder-locked",

                // tweetySupermanLockedRecap: "lmu-ui-recap-tweety-sup-locked",
                // tweetySupermanRecap: "lmu-ui-recap-tweety-sup",
                // tweetyBatmanRecap: "lmu-ui-recap-tweety-bat",
                // tweetyBatmanLockedRecap: "lmu-ui-recap-tweety-bat-locked",
            });

            batch.addImages("./assets/images/hud/", {
                hudProgressLine: "lmu-ui-hud-prog-tracker-v2",
                hudProgressMarker: "lmu-ui-hud-prog-icon",
                slamIcon: "lmu-ui-hud-slam-icon",
                slamIconGrey: "lmu-ui-hud-slam-icon-gray",
                slamIconGlow: "lmu-ui-hud-slam-icon-glow",
                slamParticleLightning: "lmu-ui-hud-slam-particle-lightning",
                slamAlert: "lmu-ui-hud-slam-alert",
                slamAlertGlow: "lmu-ui-hud-slam-alertglow",
                slamBG: "lmu-ui-hud-slam-icon-bg",
                slamBG11: "lmu-ui-hud-slam-icon-bg-11slots",
                slamBGRed: "lmu-ui-hud-slam-icon-bg-red",
                slamBG11Red: "lmu-ui-hud-slam-icon-bg-11slots-red",
                slamOn: "lmu-ui-hud-slam-on",
                slamOff: "lmu-ui-hud-slam-off",
                slamGlow: "lmu-ui-hud-slam-on-glow",
                slamLocked: "lmu-ui-hud-slam-locked",
                distanceIcon: "lmu-ui-hud-icon-distance",
                hudBacker: "lmu-ui-hud-coin-back-big",
                pauseButton: "lmu-ui-hud-pause",
                pauseButtonMobile: "lmu-ui-mobile-pause-btn",
                hudMissionBG: "lmu-ui-hud-mission-bg",
                hudMissionCheck: "lmu-ui-hud-mission-check",
                hudHitGlow: "lmu-ui-hud-hit-glow",
            });

            batch.addImages("./assets/images/gameplay/", {
                slingshot: "slingshot",
                slingshotString: "slingshot-string",
                slingshotSeat: "slingshot-seat",
                playerShadow: "wb-mash-charactershadow",
                yosemiteGlow: "lmu-ui-hud-yosemite-glow",
            });

            batch.addImages("./assets/images/ui/lmu-ui-", {
                launchMeterBG: "launch-meter-bg",
                launchMeterNeedle: "launch-meter-needle",
                launchMeterIndicator: "launch-meter-indicator",
                launchMeterGlow: "launch-meter-glow",
            });

            batch.addImages("./assets/images/gameplay/start/", {
                backlotFrontWall: "back-lot-front-wall",
                backlotFrontWallLightGlow: "back-lot-front-wall-light-glow",
                backlotFrontWallLightRays: "back-lot-front-wall-light-rays",
                backlotFrontWallTop: "back-lot-front-wall-top",
                backlotWall: "back-lot-side-wall-piece",
                backlotWallHaze: "back-lot-side-wall-purple-haze",
                backlotBlueHaze: "blue-haze",
                backlotBillboard1: "billboard-01",
                backlotBillboard2: "billboard-02",
                backlotTop: "back-lot-top",
                backlotTrumpets: "fanfaretrumpets",
                backlotFloor: "start-floor-tile",
                backlotFloorTransition: "floor-tile--transition-start-to-bedrock",
                backlotItemsLeft: "movie-set-iteams-left",
                backlotItemsRight: "midground-transition-lot-to-bedrock",
                backlotStageBottom: "stage-bottom-half",
                backlotStageTop: "stage-top-half",
                backlotStageLightBase: "stage-light-base",
                backlotStageLightBucket: "stage-light-bucket",
                backlotWBTower: "wb-tower",
            });

            batch.addImages("./assets/images/gameplay/ending/", {
                endingSkyBottom1: "lower-sky-01",
                endingSkyBottom2: "lower-sky-02",
                endingSkyTop: "upper-sky",
                endingWBTower: "wb-tower",
                endingBillboard1: "billboard-01",
                endingBillboard2: "billboard-02",
                endingBillboard3: "billboard-03",
                endingBillboard4: "billboard-04",
                endingBillboard5: "billboard-05",
                endingCrowd1: "crowd-01",
                endingCrowd2: "crowd-02",
                endingCrowd3: "crowd-end",
                endingRope: "rope-pole",
                endingRopePole: "rope-pole-end",
                endingGround: "ground-backlot",
                endingBalloons: "party-balloons",
                endingHaze: "behind-stage-haze",
                endingCharacters: "characters",
                endingPopup: "lmu-ui-end-backer",
                endingHeader: "lmu-ui-end-header",
                endingPopupBox: "lmu-ui-end-text-bg",
                endingCharacter: "lmu-porky-end-bust",
                endingExplosivePile: "lmu-acme-explosive-pile",
            });
            batch.addImages("./assets/images/gameplay/ending/confetti/lmu-end-confetti-0", {
                confetti1: "1-rectangle",
                confetti2: "2-circle",
                confetti3: "3-diamond",
                confetti4: "4-triangle",
                confetti5: "5-spiral",
            });

            batch.addImages("./assets/images/gameplay/bedrock/", {
                bedrockBGTop1: "background-upper-sky-tile-01",
                bedrockBGTop2: "background-upper-sky-tile-02",
                bedrockBG1: "background-tile-01",
                bedrockBG2: "background-tile-02",
                bedrockBG3: "background-tile-03",
                bedrockBGBottom1: "background-bottom-tile-01",
                bedrockFloor: "bedrock-floor-tile",
                bedrockMG1: "midground-mount-tile-01",
                bedrockMG2: "midground-mount-tile-02",
                bedrockMG3: "midground-mount-tile-03",
                bedrockMG4: "midground-mount-tile-04",
                bedrockFGStart: "back-greenhill-start-tile",
                bedrockFG1: "back-greenhill-tile-01",
                bedrockFG2: "back-greenhill-tile-02",
                bedrockFG3: "back-greenhill-tile-03",
                bedrockFGStartB: "front-greenhill-start-tile",
                bedrockFG1B: "front-greenhill-tile-01",
                bedrockFG2B: "front-greenhill-tile-02",
                bedrockFG3B: "front-greenhill-tile-03",
            });

            batch.addImages("./assets/images/gameplay/metropolis/", {
                metroBGTop1: "upper-sky-tile-1-v2",
                metroBGTop2: "upper-sun-tile-2",
                metroBGMid1: "skyscraper-bg-tile-1",
                metroBGMid2: "skyscraper-bg-tile-2",
                metroBGMid3: "skyscraper-bg-tile-3",
                metroBGBottom: "background-bottom-tile-01",
                metroBuildings1: "mid-ground-buildings-tile-1",
                metroBuildings2: "mid-ground-buildings-tile-2",
                metroBuildings3: "mid-ground-buildings-tile-3",
                metroBuildings4: "mid-ground-buildings-tile-4",
                metroRiver1: "river-bank-tile-1",
                metroRiver2: "river-bank-tile-2",
                metroGrass1: "grass-tile-1",
                metroGrass2: "grass-tile-2",
                metroGrassBottom: "grass-tile-bottom",
                metroTrainTrack: "train-track",
                metroTrain: "train",
                metroFloor: "metro-floor-tile",
                metroHaze: "midground-haze",
            });

            batch.addImages("./assets/images/gameplay/haunted-house/", {
                hauntSkyTop1: "background-haunted-upper-sky-tile-01",
                hauntSkyMid1: "background-tile-01",
                hauntSkyMid2: "background-tile-02-sun",
                hauntSkyMid2B: "background-tile-02",
                hauntSkyMid3: "background-tile-03",
                hauntSkyBottom1: "background-bottom-tile-01",
                hauntBackHill1: "back-hill-tile-1",
                hauntBackHill2: "back-hill-tile-2",
                hauntBackHill3: "back-hill-tile-3",
                hauntBackHill4: "back-hill-tile-4-house",
                hauntFrontHill1: "front-hill-tile-1",
                hauntFrontHill2: "front-hill-tile-02",
                hauntFence1: "fence-tile-1",
                hauntFence2: "fence-tile-2",
                hauntFence3: "fence-tile-3-stone",
                hauntFloor: "haunted-floor-tile",
                hauntHaze: "haunted-midground-haze",
            });

            batch.addImages("./assets/images/gameplay/gotham/", {
                gothamBGTop1: "background-upper-sky-tile-01",
                gothamBGTop2: "background-upper-sky-tile-02-moon",
                gothamBGMid1: "background-tile-01",
                gothamBGMid2: "background-tile-02-bat-signal",
                gothamBGMid2B: "background-tile-02",
                gothamBGMid3: "background-tile-03",
                gothamBGBottom1: "background-bottom-tile-1",
                gothamBGBottom2: "background-bottom-tile-2",
                gothamBGBottom3: "background-bottom-tile-3",
                gothamBuildings1: "gotham-mg-buildings-tile-1",
                gothamBuildings2: "gotham-mg-buildings-tile-2",
                gothamBuildings3: "gotham-mg-buildings-tile-3",
                gothamBuildings4: "gotham-mg-buildings-tile-4",
                gothamWall: "stone-wall-tile",
                gothamFloor: "gotham-floor-tile",
                gothamHaze: "gotham-midground-haze",
            });

            batch.addImages("./assets/images/gameplay/wall/", {
                wallCircle1: "break-circle-01",
                wallCircle2: "break-circle-02",
                wallCircle3: "break-circle-03",
                wallCircle4: "break-circle-04",
                wallStartTile: "front-wall-top-tile",
                wallTile: "wall-brick-tile",
                wallEnd: "wall-end",
                wallBomb: "bomb",
                wallFrontHole: "front-wall-hole",
            });

            batch.addImages('./locale/' + F84Game.Instance.locale + '/', {
                billboardBedrock: "lmu-billboard-bedrock",
                billboardGotham: "lmu-billboard-gotham",
                billboardMetropolis: "lmu-billboard-metropolis",
                billboardScooby: "lmu-billboard-scooby-doo",
                setDeco1: "acme-props",
                setSignsEnv0: "first-sign-cluster",
                setSignsEnv1: "middle-sign-cluster",
                setSignsEnv2: "last-sign-cluster",
                setDeco4: "quiet-on-set-cluster",
                backlotDangerSign: "danger-sign",
                wallStartBottom: "front-wall-bottom",
                endingSign: "party-sign",
                shopItemgrease: "lmu-ui-store-item-grease",
            });

            batch.addImages("./assets/images/gameplay/set-deco/", {
                setDeco2: "director-chair",
                setDeco3: "fog-machine",
            });
            
            batch.addImages("./assets/images/shop/lmu-ui-store-", {
                shopAlert: "alert",
                // shopBGGlow: "bg-glow",
                shopBook: "book",
                shopBackBtn: "btn-back",
                shopPlayBtn: "btn-play",
                shopCoinCounter: "coin-counter",
                shopDivider: "divider",
                shopHeader: "header",
                shopHeaderACME: "header-acme-text",
                shopItemanvil: "item-anvil",
                shopItemdetonator: "item-detonator",
                shopItemHeader: "item-header",
                shopItemsteelBall: "item-indestructo",
                shopItemMeterBacker: "meterbacker",
                shopItemMeterEmpty: "item-meter-empty",
                shopItemMeterFullRed: "item-meter-full-red",
                shopItemMeterFullBlue: "item-meter-full-blue",
                shopItemMeterFullPurple: "item-meter-full-purple",
                shopItemMeterFullYellow: "item-meter-full-yellow",
                shopItemrubberBand: "item-rubberband",
                shopDeco: "decor",
                shopTabItemActive: "tab-item-active",
                shopTabItemInactive: "tab-item-inactive",
                shopTabPlayerActive: "tab-player-active",
                shopTabPlayerInactive: "tab-player-inactive",

                charBtnSelected: "characterselect",
            });

            batch.addImages("./assets/images/shop/character-select/", {
                charBtnLocked: "lmu-ui-character-lock",
                charBtnLockFill: "lmu-ui-character-lock-fill-slice",
                charBtnBugsBat: "lmu-ui-character-bugs-bat",
                charBtnBugsFlint: "lmu-ui-character-bugs-flint",
                charBtnBugsScooby: "lmu-ui-character-bugs-scooby",
                charBtnDaffyBat: "lmu-ui-character-daffy-bat",
                charBtnDaffySup: "lmu-ui-character-daffy-sup",
                charBtnLolaFlint: "lmu-ui-character-lola-flint",
                charBtnLolaScooby: "lmu-ui-character-lola-scooby",
                charBtnLolaWonder: "lmu-ui-character-lola-wonder",
                charBtnTweetyBat: "lmu-ui-character-tweety-bat",
                charBtnTweetySup: "lmu-ui-character-tweety-sup",
                //new locked items
                charLockedBacker: "lmu-ui-character-lock-meter",
                charLock: "lmu-ui-character-lock-icon",
                // charBtnBugsBatLocked: "lmu-ui-character-bugs-bat-locked",
                charBtnBugsFlintLocked: "lmu-ui-character-bugs-flint-locked",
                charBtnBugsScoobyLocked: "lmu-ui-character-bugs-scooby-locked",
                charBtnDaffyBatLocked: "lmu-ui-character-daffy-bat-locked",
                charBtnDaffySupLocked: "lmu-ui-character-daffy-sup-locked",
                charBtnLolaFlintLocked: "lmu-ui-character-lola-flint-locked",
                charBtnLolaScoobyLocked: "lmu-ui-character-lola-scooby-locked",
                charBtnLolaWonderLocked: "lmu-ui-character-lola-wonder-locked",
                charBtnTweetyBatLocked: "lmu-ui-character-tweety-bat-locked",
                charBtnTweetySupLocked: "lmu-ui-character-tweety-sup-locked",
            });

            batch.addImages("./assets/images/shop/lmu-ui-", {
                shopCoin: "coin",
                shopButtonGlow: "store-button-glow",
            });

            batch.addImages("./assets/images/gameplay/characters/wonderwoman-slam/", {
                whip: "wb-mash-wonderwoman-rope",
            });

            batch.addSounds("./assets/audio/", {
                bounceCharacter: "bounce-character",
                bounceGround: "bounce-ground",
                bounceObject: "bounce-object",
                breakWall: "break-wall",
                characterStopped: "character-stopped",
                characterUnlocked: "character-unlocked",
                collideSpring: "collide-spring",
                collideTnt: "collide-tnt",
                crumbleWall: "crumble-wall",
                missionComplete: "mission-complete",
                perfectLaunch: "perfect-launch",
                slingshotPull: "slingshot-pull",
                slingshotRelease: "slingshot-release",
                useFirecracker: "use-firecracker",
                useSkates: "use-skates",
                purchaseBlocked: "purchase-blocked",
                purchaseItem: "purchase-item",
                slamReady: "slam-ready",
                useSlam: "use-slam",
                slamBounce: "slam-bounce",
                noSlam: "slam-unavailable",
                gameEndFireworks: "game-end-fireworks",
                hitYosemite: "hit-yosemite",
                selectCharacter: "select-character",
            }, ".mp3");

            //Environment themes
            batch.addSounds("./assets/audio/environments/", {
                bedrockTrack: "bedrock-track",
                metroTrack: "metro-track",
                scoobyTrack: "scooby-track",
                gothamTrack: "gotham-track",
                gameWin: "game-win",
            }, ".mp3");

            batch.addSpine("end-explosion", "./assets/animations/end-explosion/", "wb-end-explosion-magical", true);
            batch.addSpine("powerup-firecracker-active", "./assets/animations/powerup-firecracker-active/", "wb-firecracker-active", true);
            batch.addSpine("powerup-firecracker-ground", "./assets/animations/powerup-firecracker-ground/", "wb-powerup-firecracker-ground", true);
            batch.addSpine("powerup-firecracker-sky", "./assets/animations/powerup-firecracker-sky/", "wb-powerup-firecracker-sky", true);
            batch.addSpine("powerup-rollerskate", "./assets/animations/powerup-rollerskate/", "wb-powerup-rollerskate", true);
            batch.addSpine("powerup-trampoline", "./assets/animations/powerup-trampoline/", "wb-powerup-spring", true);
            batch.addSpine("powerup-tntcrate-ground", "./assets/animations/powerup-tntcrate-ground/", "wb-powerup-tntcrate-ground", true);
            batch.addSpine("powerup-dynamite-ground", "./assets/animations/powerup-dynamite-ground/", "wb-powerup-dynamite-ground", true);
            batch.addSpine("powerup-dynamite-sky", "./assets/animations/powerup-dynamite-sky/", "wb-powerup-dynamite-sky", true);
            batch.addSpine("coin-bag", "./assets/animations/coin-bag/", "wb-moneybag-collectable", true);
            batch.addSpine("metropolis-car-modern", "./assets/animations/metropolis-car-modern/", "eviro-metropolis-car-modern", true);
            batch.addSpine("metropolis-car-old", "./assets/animations/metropolis-car-old/", "enviro-metropolis-car-old", true);
            batch.addSpine("scooby-ghost-purple", "./assets/animations/scooby-ghost-purple/", "enviro-scooby-ghost-purple", true);
            batch.addSpine("scooby-ghost-tan", "./assets/animations/scooby-ghost-tan/", "enviro-scooby-ghost-tan", true);
            batch.addSpine("star-burst", "./assets/animations/star-burst/", "ui-starburst-idle", true);
            batch.addSpine("thunder-cloud", "./assets/animations/thunder-cloud/", "thunder-cloud", true);
            batch.addSpine("enemy-yosemitesam", "./assets/animations/enemy-yosemitesam/", "wb-enemy-yosemitesam", true);
            batch.addSpine("firework-burst", "./assets/animations/firework-burst/", "skeleton", false);
            batch.addSpine("dizzy-stars", "./assets/animations/dizzy-stars/", "dizzy-stars", true);
            batch.addSpine("game-end-particles", "./assets/animations/game-end-particleFX/", "wb-gp-gameend-particles", true);
            batch.addSpine("whoom", "./assets/animations/whoom/", "wb-gamebegin-whoom", true);
            batch.addSpine("gotham-clown-green", "./assets/animations/gotham-clown-green/", "clown-green", true);
            batch.addSpine("gotham-clown-pink", "./assets/animations/gotham-clown-pink/", "clown-pink", true);
            batch.addSpine("gotham-clown-mohawk", "./assets/animations/gotham-clown-mohawk/", "clown-mohawk", true);
            batch.addSpine("player-glow", "./assets/animations/player-glow/", "wb-gp-player-glow", true);
            batch.addSpine("player-smash-batman", "./assets/animations/player-smash-batman/", "wb-player-batman-smash", true);
            batch.addSpine("player-smash-scooby", "./assets/animations/player-smash-scooby/", "wb-player-scooby-smash", true);
            batch.addSpine("player-smash-flinstones", "./assets/animations/player-smash-flinstones/", "wb-player-flintstones-smash", true);
            batch.addSpine("player-smash-superman", "./assets/animations/player-smash-superman/", "wb-player-superman-smash", true);
            batch.addSpine("player-smash-wonderwoman", "./assets/animations/player-smash-wonderwoman/", "wb-player-wonderwoman-smash", true);
            batch.addSpine("player-smash-text", "./assets/animations/player-smash-text/", "wb-player-batman-text", true);
            batch.addSpineImageAtlas("coin-sheet", "./assets/animations/coin-sheet/", "wb-coin-all");

            // npcs
            batch.addSpine("npc-bugs", "./assets/animations/NPCs/npc-bugs/", "wb-npc-bugs", true);
            batch.addSpine("npc-daffy", "./assets/animations/NPCs/npc-daffy/", "wb-npc-daffy", true);
            batch.addSpine("npc-lola", "./assets/animations/NPCs/npc-lola/", "wb-npc-lola", true);
            batch.addSpine("npc-porky", "./assets/animations/NPCs/npc-porky/", "wb-npc-porky", true);
            batch.addSpine("npc-roadrunner", "./assets/animations/NPCs/npc-roadrunner/", "wb-npc-roadrunner", true);
            batch.addSpine("npc-sylvester", "./assets/animations/NPCs/npc-sylvester/", "wb-npc-sylvester", true);
            batch.addSpine("npc-taz", "./assets/animations/NPCs/npc-taz/", "wb-npc-taz", true);
            batch.addSpine("npc-tweety", "./assets/animations/NPCs/npc-tweety/", "wb-npc-tweety", true);
            batch.addSpine("npc-wile", "./assets/animations/NPCs/npc-wile/", "wb-npc-wile", true);
            batch.addSpine("bedrock-stone", "./assets/animations/NPCs/bedrock-stone/", "wb-bedrock-stone", true);
            batch.addSpine("player-impact-puff", "./assets/animations/NPCs/player-impact-puff/", "wb-player-impact", true);

            // wall smash
            batch.addSpine("wall-smash-breakin", "./assets/animations/wall-smash/wall-smash-breakin/", "wb-wallsmash-breakIN");
            batch.addSpine("wall-smash-breakout", "./assets/animations/wall-smash/wall-smash-breakout/", "wb-wallsmash-breakOUT");
            batch.addSpine("wall-smash-splat", "./assets/animations/wall-smash/wall-smash-splat/", "wb-smashwall-splat");

            batch.addAtlas("wallChunks", "./assets/images/gameplay/wall/", "wall-chunks", "wall-chunks");

            const chunks = F84Game.Instance.cache.json.get("chunks") as string[];
            for (const key of chunks) {
                batch.addJson(key, "./assets/json/chunks/" + key + ".json", false);
            }

            const layouts = F84Game.Instance.cache.json.get("coin-layouts") as string[];
            for (const key of layouts) {
                batch.addJson(key, "./assets/json/coin-layouts/" + key + ".json", false);
            }
        }
        return batch;
    }

    static Character(currentCharacter: CharacterUnlockData): LoadBatch {
        const batch = F84Game.Instance.loadBatches.get("gameplay-" + currentCharacter.name);
        if (batch.assets.size == 0) {
            // Characters must also be added to CharacterAtlas.ts
            const addCharacterImages = (character: string, prefix: string, suffix = ".png", hasLowQuality = false) => {
                if (character != currentCharacter.name) return;
                batch.addAtlas(character, prefix, "sheet", "sheet", hasLowQuality);
            }
            
            addCharacterImages("bugsBatman", "./assets/images/gameplay/characters/wb-mash-bugs-batman-");
            addCharacterImages("bugsFredScooby", "./assets/images/gameplay/characters/wb-mash-bugs-scoobfreddie-");
            addCharacterImages("bugsFredFlinstone", "./assets/images/gameplay/characters/wb-mash-bugs-flinstonesfred-");
            addCharacterImages("daffySuperman", "./assets/images/gameplay/characters/wb-mash-daffy-superman-");
            addCharacterImages("lolaWonderwoman", "./assets/images/gameplay/characters/wb-mash-lola-wonderwoman-");
            addCharacterImages("lolaFlintstones", "./assets/images/gameplay/characters/wb-mash-lola-wilma-");
            addCharacterImages("lolaDaphne", "./assets/images/gameplay/characters/wb-mash-lola-daphne-");
            addCharacterImages("tweetyBatman", "./assets/images/gameplay/characters/wb-mash-tweety-batman-");
            addCharacterImages("tweetySuperman", "./assets/images/gameplay/characters/wb-mash-tweety-superman-");
            addCharacterImages("daffyBatman", "./assets/images/gameplay/characters/wb-mash-daffy-batman-");
        }
        return batch;
    }

    static UnlockedCharacter(character: CharacterUnlockData):LoadBatch{
        const batch = F84Game.Instance.loadBatches.get("gameplay-" + character.unlockString);
        if (batch.assets.size == 0) {
            batch.addImages("./assets/images/character-unlock/",{
                nextUnlockedCharRecap: `${character.unlockString}`,
                nextUnlockedCharLockedRecap: `${character.unlockString}-locked`,
            });
        }
        return batch;
    }
}
